import React from 'react'
import {SignIn} from '../../component/index'
function PgSignIn() {
    return (
        <SignIn/>
    )
}

export default PgSignIn
